import {Dispatch} from 'redux';
import {sportEventsByGroupId} from 'API/sportEvents';
import {
  SPORTEVENTS_BY_GROUP_ID_GET_INVALIDATE,
  SPORTEVENTS_BY_GROUP_ID_GET_REQUEST,
  SPORTEVENTS_BY_GROUP_ID_GET_RESPONSE,
} from '../../actionTypes';
import {
  SportEventsByGroupIdGetInvalidateAction,
  SportEventsByGroupIdGetRequestAction,
  SportEventsByGroupIdGetResponseAction,
} from '../types';
import {CompetitionTablesTeam, MatchSimple} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {beMatchSimpleToMatchSimple, beStandingToCompetitionTableTeams} from '../../../API/utils';
import {standingBySeasonIdOrGroupName} from '../../../API/standings';

/**
 * Action creator for the get request of the competitionTables by season id and groupname
 * @param id
 */
const getSportEventsByGroupIdGetRequest = (): SportEventsByGroupIdGetRequestAction => ({
  type: SPORTEVENTS_BY_GROUP_ID_GET_REQUEST,
});

/**
 * Action creator for the get response of the competitionTables by season id and groupname
 */
const getSportEventsByGroupIdGetResponse = (
  matches: MatchSimple[]
): SportEventsByGroupIdGetResponseAction => ({
  type: SPORTEVENTS_BY_GROUP_ID_GET_RESPONSE,
  payload: {data: matches},
});

/**
 * Action creator for the get invalidation of the competitionTables by season id and groupname
 * @param error
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getSportEventsByGroupIdGetInvalidate = (error: Error): SportEventsByGroupIdGetInvalidateAction => ({
  type: SPORTEVENTS_BY_GROUP_ID_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * Thunk for getting the team competitionTables in the current season and group
 * @param seasonId
 * @param groupName
 */
const getSportEventsByGroupId =
  (groupId: string) =>
  (dispatch: Dispatch): Promise<any> => {
    dispatch(getSportEventsByGroupIdGetRequest());

    return sportEventsByGroupId(groupId)
      .then(results => results.map(beMatchSimpleToMatchSimple))
      .then((matches: MatchSimple[]) => dispatch(getSportEventsByGroupIdGetResponse(matches)))
      .catch((error: Error) => dispatch(getSportEventsByGroupIdGetInvalidate(error)));
  };

export default getSportEventsByGroupId;
